import { FC } from "react";
import { Container } from "../../shared/ui";

import { data } from "./const/data";

import styles from "./InvestmentStage.module.scss";
import { BenefitCard } from "./ui/BenefitCard";

export const InvestmentStage: FC = () => (
    <Container marginSize="standard" className={styles.investmentStage}>
        <div className={styles.investmentStage__item}>
            {data.map((item) => (
                <BenefitCard key={item.id} {...item} />
            ))}
        </div>
    </Container>
);

export default InvestmentStage;
